import Demand from 'Constants/demand';

export default {
  methods: {
    isDivaDemand(demand) {
      return demand.type === Demand.TYPE.DIVA;
    },
    isStrategicDemand(demand) {
      return demand.type === Demand.TYPE.STRATEGIC;
    },
    isNeverOutOfStockDemand(demand) {
      return demand.type === Demand.TYPE.NEVER_OUT_OF_STOCK;
    },
    isOldDemand(demand) {
      return demand.type === Demand.TYPE.OLD;
    },
  },
};
